import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


enum operationApprovalStatusForUser {

	rejectStatusType = 0,
	approvalStatusType = 1,
	waitingStatusType = 2,
}


@Component({
  selector: 'kt-approve-status-modal',
  templateUrl: './approve-status-modal.component.html',
  styleUrls: ['./approve-status-modal.component.scss']
})
export class ApproveStatusModalComponent implements OnInit {


	@Input() approvalUsers;
	@Input() approvalUsersHasPersonInCharge;

	approvalStatus = "";

	constructor(private modalService: NgbModal) { }

	ngOnInit() {

    }
	

	modalClose() {
		this.modalService.dismissAll();
	}

}
